import { Link } from 'react-router-dom';
import { useEffect } from 'react';

function TechnicalProjectManager() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const position = {
    title: 'Technical Project Manager',
    department: 'Engineering',
    location: 'Worldwide (Remote)',
    type: 'Full-Time',
    salaryRange: '$700-$1,200 USD',
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <Link
            to="/careers"
            className="text-[#0049ac] hover:text-[#0049ac]/90 flex items-center"
          >
            ← Back to Careers
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="bg-white rounded-lg shadow-xl overflow-hidden">
              <div className="p-8">
                <div className="mb-8">
                  <h1 className="text-3xl font-bold text-gray-900 mb-4">{position.title}</h1>
                  <div className="flex items-center gap-2 mb-6">
                    <p className="text-gray-500">{position.department} • {position.location} • {position.type}</p>
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      {position.salaryRange}
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-3">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                      Full Remote
                    </span>
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-800">
                      SellAbroad
                    </span>
                  </div>
                </div>

                <div className="prose max-w-none">
                  <div className="mb-8">
                    <h2 className="text-xl font-semibold mb-4">About SellAbroad</h2>
                    <p>
                      SellAbroad is a dynamic platform dedicated to empowering businesses to expand internationally. We provide seamless cross-border e-commerce solutions—from localized storefronts and multi-currency payment processing to international shipping logistics and market insights. Our mission is to simplify global selling so that businesses can focus on what they do best: creating exceptional products and services.
                    </p>
                  </div>

                  <div className="mb-8">
                    <h2 className="text-xl font-semibold mb-4">The Role</h2>
                    <p>
                      As a Technical Project Manager at SellAbroad, you will oversee the end-to-end planning, execution, and delivery of complex software projects that power our global e-commerce platform. You'll collaborate closely with cross-functional teams—engineering, design, product management, and operations—to ensure that project goals are met on time, within scope, and with high-quality standards.
                    </p>
                  </div>

                  <div className="mb-8">
                    <h2 className="text-xl font-semibold mb-4">Key Responsibilities</h2>
                    <ul className="list-disc pl-5">
                      <li>Coordinate and manage all phases of the project lifecycle, from initial planning to final delivery</li>
                      <li>Develop detailed project plans, schedules, and resource allocations in alignment with organizational priorities</li>
                      <li>Collaborate with cross-functional teams to identify dependencies, risks, and mitigation strategies</li>
                      <li>Implement Agile or hybrid methodologies, facilitating daily stand-ups, sprint planning, and retrospectives</li>
                      <li>Communicate project status, progress, and issues to stakeholders and leadership in a clear, concise manner</li>
                      <li>Track and report key performance indicators (KPIs) to ensure project objectives are met</li>
                      <li>Foster a collaborative and results-driven culture within the project team</li>
                    </ul>
                  </div>

                  <div className="mb-8">
                    <h2 className="text-xl font-semibold mb-4">Qualifications</h2>
                    <ul className="list-disc pl-5">
                      <li>3–5 years of experience managing technical projects, preferably in e-commerce, SaaS, or a related technology field</li>
                      <li>Proven track record of successfully delivering projects on time and within scope</li>
                      <li>Strong understanding of Agile methodologies (e.g., Scrum or Kanban) and related project management tools</li>
                      <li>Excellent communication and stakeholder management skills</li>
                      <li>Ability to navigate complex technical discussions and translate requirements between technical and non-technical stakeholders</li>
                      <li>Experience with risk management, resource planning, and budget tracking</li>
                      <li>Bachelor's degree in Computer Science, Engineering, Business, or a related field (advanced degrees or relevant certifications are a plus)</li>
                    </ul>
                  </div>

                  <div className="mb-8">
                    <h2 className="text-xl font-semibold mb-4">What We Offer</h2>
                    <ul className="list-disc pl-5">
                      <li>A collaborative and innovative work environment focused on global impact</li>
                      <li>Opportunities for professional growth and advancement</li>
                      <li>Competitive salary and benefits package</li>
                      <li>The chance to be a key player in shaping the future of international e-commerce</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-1">
            <div className="sticky top-24">
              <div className="bg-white rounded-lg shadow-xl p-6">
                <h2 className="text-lg font-semibold text-gray-900 mb-4">Apply for this Position</h2>
                <p className="text-gray-600 mb-6">
                  Join our team and help transform e-commerce in the MENA region.
                </p>
                <Link
                  to="/careers/technical-project-manager/apply"
                  className="w-full flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#0049ac] hover:bg-[#0049ac]/90 transition-all duration-200"
                >
                  Apply Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TechnicalProjectManager; 